var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-grid',{ref:"grid",attrs:{"url":"ivrCalls","baseUrl":"https://dinner-compaign.azurewebsites.net","columns":_vm.columns,"title":_vm.title,"sortOptions":{
            enabled: true,
            field: 'date',
            type: 'desc',
        },"expandedOptions":{
            enabled: true,
            template: 'dinner-ivr-call-details',
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }